import { useEffect, useState } from "react";
import { useClientAuth } from "../contexts/ClientAuthContext";
import { api } from "../lib/api";
import PortalTopbar from "../components/portal/PortalTopbar";
import OnboardingGate from "../components/portal/OnboardingGate";
import WorkoutDashboard from "../components/portal/WorkoutDashboard";
import HabitTracker from "../components/portal/HabitTracker";
import CheckinForm from "../components/portal/CheckinForm";
import CommunityFeed from "../components/portal/CommunityFeed";
import PortalMessages from "../components/portal/PortalMessages";

export default function PortalPage() {
  const { client } = useClientAuth();
  const [waiver, setWaiver] = useState(null);
  const [checking, setChecking] = useState(true);
  const [tab, setTab] = useState("workout");

  useEffect(() => {
    api
      .get("/portal/waiver")
      .then(({ data }) => setWaiver(data))
      .catch(() => setWaiver(null))
      .finally(() => setChecking(false));
  }, []);

  if (checking) return <div className="min-h-screen bg-[#0A0A0A]" />;

  if (!waiver) {
    return <OnboardingGate onComplete={(w) => setWaiver(w)} clientName={client?.name} />;
  }

  return (
    <div data-testid="portal-page" className="min-h-screen bg-[#0A0A0A] pb-16">
      <PortalTopbar tab={tab} setTab={setTab} clientName={client?.name} clientPicture={client?.picture} />
      <main className="max-w-5xl mx-auto px-6 pt-28">
        {tab === "workout" && <WorkoutDashboard />}
        {tab === "habits" && <HabitTracker />}
        {tab === "checkin" && <CheckinForm />}
        {tab === "community" && <CommunityFeed />}
        {tab === "messages" && <PortalMessages />}
      </main>
    </div>
  );
}
